<template>
  <md-card>
    <md-card-header>
      <div class="md-layout">
        <div class="md-layout-item md-size-90">
          <h4 class="title">Email Content</h4>
        </div>
      </div>
    </md-card-header>
    <md-card-content>
      <div class="email-content" id="departure-email-header">
        <div class="md-layout">
          <div class="md-layout-item md-size-80">
            <h6 class="subhead">Email 1</h6>
          </div>
          <div class="md-layout-item md-size-20 text-right">
            <md-button
              v-if="emailHeader.hasOverride && canEdit"
              class="md-just-icon md-simple md-danger"
              @click="clearContent({ prop: 'email_header' })"
            >
              <md-icon>clear</md-icon>
              <md-tooltip md-direction="top"
                >Clear the Departure Override</md-tooltip
              >
            </md-button>
            <md-button
              v-if="canEdit"
              class="md-just-icon md-simple md-success"
              @click="
                editContent({
                  title: 'Email 1',
                  prop: 'email_header',
                  value: departure.email_header
                })
              "
            >
              <md-icon>edit</md-icon>
              <md-tooltip md-direction="top">Edit and Override</md-tooltip>
            </md-button>
          </div>
          <div class="md-layout-item md-size-100">
            <h6 v-if="!emailHeader.hasOverride" class="text-danger tagline">
              <small>This is set at the Adventure level</small>
            </h6>
            <span v-html="emailHeader.content"></span>
          </div>
        </div>
      </div>

      <div class="email-content" id="departure-email-footer">
        <div class="md-layout">
          <div class="md-layout-item md-size-80">
            <h6 class="subhead">Email 2</h6>
          </div>
          <div class="md-layout-item md-size-20 text-right">
            <md-button
              v-if="emailFooter.hasOverride && canEdit"
              class="md-just-icon md-simple md-danger"
              @click="clearContent({ prop: 'email_footer' })"
            >
              <md-icon>clear</md-icon>
              <md-tooltip md-direction="top"
                >Clear the Departure Override</md-tooltip
              >
            </md-button>
            <md-button
              v-if="canEdit"
              class="md-just-icon md-simple md-success"
              @click="
                editContent({
                  title: 'Email 2',
                  prop: 'email_footer',
                  value: departure.email_footer
                })
              "
            >
              <md-icon>edit</md-icon>
              <md-tooltip md-direction="top">Edit and Override</md-tooltip>
            </md-button>
          </div>
          <div class="md-layout-item md-size-100">
            <h6 v-if="!emailFooter.hasOverride" class="text-danger tagline">
              <small>This is set at the Adventure level</small>
            </h6>
            <span v-html="emailFooter.content"></span>
          </div>
        </div>
      </div>
    </md-card-content>
    <notes-dialog
      :showNotesDialog.sync="showDialog"
      :note="note"
      :title="dialogTitle"
      @saveNote="saveContent"
    />
  </md-card>
</template>

<script>
import tourApi from "@/services/api/tour";
import NotesDialog from "@/components/Handi/Notes/NotesDialog.vue";

export default {
  name: "DepartureTabsEmail",

  components: {
    NotesDialog
  },

  props: {
    departure: {
      type: Object,
      default: null
    }
  },

  computed: {
    canEdit() {
      return this.$allowed(["departure.email.manage"]);
    },
    isSupplier() {
      return (
        this.departure.tour.supplier.id ==
        this.$store.state.auth.user.supplier.id
      );
    },
    emailHeader() {
      return {
        hasOverride: !!this.departure.email_header,
        content: !!this.departure.email_header
          ? this.departure.email_header
          : this.departure.tour.email_header
      };
    },
    emailFooter() {
      return {
        hasOverride: !!this.departure.email_footer,
        content: !!this.departure.email_footer
          ? this.departure.email_footer
          : this.departure.tour.email_footer
      };
    }
  },

  methods: {
    editContent(editableContent) {
      this.dialogTitle = editableContent.title;
      this.editableProp = editableContent.prop;
      this.note = { content: editableContent.value };
      this.showDialog = true;
    },
    clearContent(editableContent) {
      this.editableProp = editableContent.prop;
      this.saveContent({ content: null });
    },
    saveContent(note) {
      this.departure[this.editableProp] = note.content;
      tourApi
        .updateDeparture(this.departure.tour.id, this.departure)
        .then(() => {
          this.$notify({
            timeout: 2500,
            message: "Email Info has been updated.",
            icon: "thumb_up",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "success"
          });
        });
      this.showDialog = false;
    }
  },

  data() {
    return {
      showDialog: false,
      note: null,
      dialogTitle: null,
      editableProp: null
    };
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/md/_variables.scss";

.email-content {
  border-bottom: 1px solid $brand-primary;
  margin-bottom: 2rem;

  h6.tagline,
  h6.subhead {
    margin: 0;
  }

  .md-button {
    margin: 0;
    padding: 5px;
    height: 27px;
    min-width: 27px;
    width: 27px;
    line-height: 27px;
  }
}
</style>
